export default __webpack_public_path__ + "static/media/Mountain.679f9b3f.webp";